import React from 'react';
import {Icon} from '../../elements/Icon/Icon';
import {Btn} from '../../elements/button/btn-type/Btn';
import {useFormikContext} from 'formik';
import {Sidebar} from '../../modal/modal-features/Sidebar';
import {FilterPanel} from '../../../data-ui/list-page-shared/FilterPanel';

import _ from 'lodash';
import {Aside, AsideBodyScroll} from '../aside/Aside';

export const FilterPanelFormContent = ({entityType, filters, validFilterFormatters, arrayHelpers, t}) => {
    const {values, handleSubmit, setFieldValue} = useFormikContext();

    // check when the current filters applied to the table are different from the form
    const dirty = !_.isEqual(values.filters, filters);

    return (
        <>
            <AsideBodyScroll>
                <Aside.Row>
                    <FilterPanel
                        entityType={entityType}
                        arrayHelpers={arrayHelpers}
                        handleSubmit={handleSubmit}
                        validFilterFormatters={validFilterFormatters}
                        t={t}
                    />
                </Aside.Row>
            </AsideBodyScroll>

            <Aside.Footer>
                {!_.isEmpty(validFilterFormatters) && (
                    <Btn ghost color={dirty ? 'primary' : 'disabled'} type="button" onClick={handleSubmit}>
                        <Icon name="FilterList" />
                        {t('filterPanel.applyFilter')}
                    </Btn>
                )}
                <Btn
                    type="button"
                    color="danger"
                    ghost={true}
                    disabled={_.isEmpty(values.filters)}
                    onClick={async () => {
                        await setFieldValue('filters', []);
                        handleSubmit();
                    }}>
                    <Icon type="sm" name="clear" />
                    {t('generalShared.clearAll')}
                </Btn>
            </Aside.Footer>
        </>
    );
};

FilterPanelFormContent.displayName = 'FilterPanelFormContent';

FilterPanelFormContent.Body = Sidebar.Body;
FilterPanelFormContent.Footer = Sidebar.Footer;
FilterPanelFormContent.Wrapper = Sidebar.Content;
